import produce from 'immer';

import {
  MUNICIPAL_CODE_FETCH_FAILURE,
  MUNICIPAL_CODE_FETCH_REQUEST,
  MUNICIPAL_CODE_FETCH_SUCCESS,
  MUNICIPAL_CODES_FETCH_FAILURE,
  MUNICIPAL_CODES_FETCH_REQUEST,
  MUNICIPAL_CODES_FETCH_SUCCESS,
} from '@actions/municipalCode';

const initialState: IMuncipalCodeStore = {
  currentMuncipalCode: null,
  muncipalCodes: null,
  error: null,
};

export default (state: IMuncipalCodeStore = initialState, action: any) =>
  produce(state, (draftState: IMuncipalCodeStore) => {
    switch (action.type) {
      case MUNICIPAL_CODES_FETCH_REQUEST:
        draftState.error = null;

        return;
      case MUNICIPAL_CODES_FETCH_SUCCESS:
        draftState.muncipalCodes = action.response;
        draftState.error = null;

        return;
      case MUNICIPAL_CODES_FETCH_FAILURE:
        draftState.muncipalCodes = null;
        draftState.error = action.error;

        return;
      case MUNICIPAL_CODE_FETCH_REQUEST:
        draftState.currentMuncipalCode = null;
        draftState.error = null;

        return;
      case MUNICIPAL_CODE_FETCH_SUCCESS:
        draftState.currentMuncipalCode = action.response;
        draftState.error = null;

        return;
      case MUNICIPAL_CODE_FETCH_FAILURE:
        draftState.currentMuncipalCode = null;
        draftState.error = action.error;

        return;
    }
  });
